import { ILogin } from '@/common/interfaces/login.interface';
import CookieHelper from '@/helpers/CookieHelper';
import LocalStorageHelper from '@/helpers/LocalStorageHelper';
import NewsHelper from '@/helpers/NewsHelper';
import SentryHelper from '@/helpers/SentryHelper';
import SessionStorageHelper from '@/helpers/SessionStorageHelper';
import ValidationHelper from '@/helpers/ValidationHelper';
import ApiService from '@/services/ApiService';

export default class LoginService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  public async afterSuccessfulLogin(data: ILogin): Promise<void> {
    CookieHelper.removeAuthToken();
    CookieHelper.removeCartSession();
    LocalStorageHelper.removeLoginInformation();

    CookieHelper.setAuthToken(data.account.authToken);
    CookieHelper.setCartSession(data.session);
    LocalStorageHelper.setPersonalInfo(data);

    LocalStorageHelper.setCartItemsCount(await this.apiService.getCartCount());
    await LoginService.setNewNewsPostsIDsAndCountInLocalStorage();

    if(window.sentryInitialized) {
      SentryHelper.setSentryTags();
    }

    const loginRedirect = SessionStorageHelper.getRedirect();
    SessionStorageHelper.removeRedirect();
    if(loginRedirect && ValidationHelper.checkIfTargetIsValidLoginRedirectTarget(loginRedirect)) {
      window.location.href = loginRedirect;
    } else {
      window.location.href = `/`;
    }
  }

  private static async setNewNewsPostsIDsAndCountInLocalStorage(): Promise<void> {
    const newNews = await NewsHelper.getNewNewsPostsIDsAndCount();

    LocalStorageHelper.setNewNewsCount(newNews.count);
    LocalStorageHelper.setNewNewsPostsIDS(newNews.IDs);
  }
}
